module.exports = __webpack_public_path__ + "static/media/homeMobile.700bf193.jpg";